import { TenantCountryCodeEnum } from 'probonio-shared-ui/api';

export type CountryCode = TenantCountryCodeEnum;

export const CountryCode = TenantCountryCodeEnum;
